export default __webpack_public_path__ + "static/media/logo_text_white.15da545a.png";